import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from '../../ColorSwatch.styles';

var capitalizeEachWord = function capitalizeEachWord(str) {
  return str.split(' ').map(function (word) {
    var _word$charAt, _word$slice;

    return ((_word$charAt = word.charAt(0)) === null || _word$charAt === void 0 ? void 0 : _word$charAt.toUpperCase()) + ((_word$slice = word.slice(1)) === null || _word$slice === void 0 ? void 0 : _word$slice.toLowerCase());
  }).join(' ');
};

var getColourFabricImage = function getColourFabricImage(color, fabric, imageLength) {
  return {
    src: encodeURI("https://media.4rgos.it/i/Argos/MTO-".concat(color, "-").concat(fabric)),
    alt: "".concat(color, " ").concat(fabric),
    height: imageLength,
    width: imageLength,
    cropParams: {
      xCoord: 0,
      yCoord: 0,
      cropWidth: 800,
      cropHeight: 800
    }
  };
};

var FabricTileSwatch = function FabricTileSwatch(_ref) {
  var color = _ref.color,
      fabric = _ref.fabric,
      id = _ref.id,
      selected = _ref.selected,
      swatchAnchorLink = _ref.swatchAnchorLink,
      size = _ref.size,
      dataTest = _ref['data-test'];
  var imageLength = size === 'medium' ? 32 : 24;
  var imageProps = getColourFabricImage(capitalizeEachWord(color), fabric, imageLength);
  return /*#__PURE__*/React.createElement(Styled.FabricSwatch, {
    $imageLength: imageLength,
    role: !swatchAnchorLink ? 'button' : undefined,
    "aria-label": !swatchAnchorLink ? id : undefined,
    tabIndex: !swatchAnchorLink ? '0' : undefined,
    "data-test": "".concat(dataTest, "-").concat(id, "-button"),
    "aria-selected": selected
  }, /*#__PURE__*/React.createElement(Styled.FabricTile, _extends({}, imageProps, {
    "data-test": "".concat(dataTest, "-").concat(id, "-image")
  })));
};

FabricTileSwatch.propTypes = {
  /**
   * Specify the color id
   */
  color: PropTypes.string.isRequired,

  /**
   * Optional prop for the fabric type when displaying as fabric swatches
   */
  fabric: PropTypes.string,

  /**
   * Optional prop to specify the id
   */
  id: PropTypes.string,

  /**
   * Optional prop to select the color
   */
  selected: PropTypes.bool,

  /**
   * Optional prop to remove button role, tabIndex and aria-label attributes
   */
  swatchAnchorLink: PropTypes.bool,

  /**
   * Optional prop to change size of the circle (small, medium)
   */
  size: PropTypes.oneOf(['small', 'medium']),

  /**
   * Specify an optional data-test attribute to be added for e2e testing
   */
  'data-test': PropTypes.string
};
export default FabricTileSwatch;